// Pegawai-only templates for "Butiran Aduan (Borang 5)".
// Source: Format Aduan Mengikut Kesalahan.pdf (pdftotext -> JSON).

import templates from './borang5OfficerTemplates.json';

export const BORANG5_OFFICER_TEMPLATES = templates;
export default templates;

